import React from 'react';

import {Card, Stack} from "@mui/joy";
import Button from "@mui/joy/Button";

// components
import BaseApi from "../../utils/BaseApi";
import MessageImage from "./MessageImage";
import MessageAudio from "./MessageAudio";
import MessageVideo from "./MessageVideo";
import MessageAttachment from "./MessageAttachment";
import MessageLink from "./MessageLink";


class RoomAttachments extends React.Component {
    constructor(props) {
        super(props);
        this.modes = {
            IMAGE: {
                xtype: 'UPLOAD',
                extensions: [
                    'png', 'jpg', 'jpeg', 'bmp', 'webp', 'gif', 'avif', 'svg', 'tiff',
                ],
                component: MessageImage,
            },
            DOCUMENT: {
                xtype: 'UPLOAD',
                extensions: [
                    'doc', 'docx', 'xls', 'xlsx'
                ],
                component: MessageAttachment,
            },
            LINK: {
                xtype: 'LINK',
                extensions: [],
                component: MessageLink,
            },
            AUDIO: {
                xtype: 'UPLOAD',
                extensions: [
                    'mp3', 'aac', 'wav', 'webm', 'ogg', 'm4a',
                ],
                component: MessageAudio,
            },
            VIDEO: {
                xtype: 'UPLOAD',
                extensions: [
                    'mp4', 'avi',
                ],
                component: MessageVideo,
            },
        }
        this.state = {
            mode: 'DOCUMENT',
            messages: []
        }
    }

    async componentDidMount() {
        await this.retrieveMessages()
    }

    async componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.roomSubscriber.id !== this.props.roomSubscriber.id) {
            await this.retrieveMessages()
        }
    }

    async retrieveMessages(){
        this.setState({
            messages: []
        })
        const url = `message/`;
        const api = new BaseApi();
        let params = {
            room: this.props.room.id,
            page_size: 10000,
            xtype: this.modes[this.state.mode].xtype,
            extension: this.modes[this.state.mode].extensions,
        };
        let response = await api.get(
            url,
            params,
            'repeat'
        );
        this.setState({
            messages: response.data.results
        })
    }

    setMode(value){
        this.setState(
            {
                mode: value
            },
            () => {
                this.retrieveMessages().then(r => {})
            }
        )
    }

    render() {
        const ModeComponent = this.modes[this.state.mode].component;
        return(
            <Stack
                spacing={1}
                sx={{
                    width: '295px',
                    overflowY: 'scroll'
                }}
            >
                <Card
                    size={'sm'}
                    variant={'soft'}
                >
                    <Stack
                        direction={'row'}
                        spacing={0.5}
                        sx={{
                            width: '100%',
                            overflowX: 'scroll',
                            minHeight: '36px',
                            maxHeight: '36px',
                        }}
                    >
                        <Button
                            size={'sm'}
                            variant={this.state.mode === 'DOCUMENT' ? 'solid' : 'soft'}
                            onClick={() => {
                                this.setMode('DOCUMENT')
                            }}
                        >
                            Документ
                        </Button>
                        <Button
                            size={'sm'}
                            variant={this.state.mode === 'IMAGE' ? 'solid' : 'soft'}
                            onClick={() => {
                                this.setMode('IMAGE')
                            }}
                        >
                            Изображение
                        </Button>
                        <Button
                            size={'sm'}
                            variant={this.state.mode === 'LINK' ? 'solid' : 'soft'}
                            onClick={() => {
                                this.setMode('LINK')
                            }}
                        >
                            Ссылка
                        </Button>
                        <Button
                            size={'sm'}
                            variant={this.state.mode === 'AUDIO' ? 'solid' : 'soft'}
                            onClick={() => {
                                this.setMode('AUDIO')
                            }}
                        >
                            Аудио
                        </Button>
                        <Button
                            size={'sm'}
                            variant={this.state.mode === 'VIDEO' ? 'solid' : 'soft'}
                            onClick={() => {
                                this.setMode('VIDEO')
                            }}
                        >
                            Видео
                        </Button>
                    </Stack>
                </Card>
                <Stack
                    direction={'row'}
                    useFlexGap
                    sx={{
                        flexWrap: 'wrap',
                    }}
                    alignItems={'center'}
                    spacing={1}
                >
                    {
                        this.state.messages.map((m) => {
                            return(
                                <ModeComponent
                                    key={'modeComponent' + m.id}
                                    message={m}
                                />
                            )
                        })
                    }
                </Stack>
            </Stack>
        )
    }
}

export default RoomAttachments
